import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/insert-management/create/index.html';

const links: Record<string, string> = {
  insert: '/infoTrac/insert-management',
  submit: '/infoTrac/insert-management?act=saved',
};

function InsertManagementCreate() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const insert = iframeDocument.getElementsByClassName('insert-management');
      const submit = iframeDocument.getElementsByClassName('saveBtn');

      if (insert.length) {
        for (let i = 0; i < insert.length; i++) {
          insert[i].addEventListener('click', () => navigate(links.insert));
        }
      }

      if (submit.length) {
        for (let i = 0; i < submit.length; i++) {
          submit[i].addEventListener('click', () => navigate(links.submit));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="insert-management-create" src={path} width="100%" height="700px" />;
}

export default InsertManagementCreate;
